export const properties = {
    identificador: 'IDENTIFICADOR'
}